<template>
  <transition name="alert">
    <div class="modal" role="dialog">
      <div class="modal-mask"></div>
      <div class="modal-wrap">
        <div class="modal-content">
          <div class="modal-header" v-if="title">{{ title }}</div>
          <slot></slot>
        </div>
        <div class="modal-button" v-if="showText(okText) || showText(cancelText)">
          <a
            v-if="showText(cancelText)"
            @click="onCancelClick"
            :href="cancelHref"
          >
            {{ cancelText }}
          </a>
          <a
            v-if="showText(okText)"
            @click="onOkClick"
            :href="okHref"
          >
            {{ okText }}
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: String,
    okText: [String, Boolean],
    cancelText: [String, Boolean],
    okHref: String,
    cancelHref: String,
  },

  methods: {
    showText (val) {
      return val !== false && val != null
    },

    onCancelClick (e) {
      this.$emit('cancel', e)
    },

    onOkClick (e) {
      this.$emit('ok', e)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/modal-core.vue